document.addEventListener('DOMContentLoaded', function () {


    const scrollBtn = document.querySelector('.scroll-top-btn');
    const showHeight = window.innerHeight; // Высота экрана пользователя

    // Функция проверки прокрутки

    let acceptedCookies = document.cookie.split('; ').find((row) => row.startsWith('accepted='));

    if (!acceptedCookies) {
        setTimeout(() => {
            const cookieBlock = document.querySelector('.cookie-wrap');
            if(cookieBlock) {
                // cookieBlock.style.cssText += 'display: flex;';
                // cookieBlock.style.cssText += 'transform: translate(0, 0px);';
                cookieBlock.style.cssText += ' opacity: 1;';
                cookieBlock.style.cssText += ' z-index: 21474836457;';
                cookieBlock.style.cssText += ' transition: opacity 0.3s ease-out;';

                document.querySelector('.cookie-btn').addEventListener('click', function () {
                    document.cookie = "accepted=true";
                    // cookieBlock.style.cssText = 'display: none;';
                    cookieBlock.style.cssText = 'opacity: 0;';
                    setTimeout(() => {
                        cookieBlock.style.cssText = 'display: none;';
                    }, 600)

                })
            }

        }, 600)

    }

    function checkScroll() {
        const scrolled = window.scrollY;

        if (scrolled > showHeight) {
            scrollBtn.classList.add('visible');
        } else {
            scrollBtn.classList.remove('visible');
        }
    }

    // Функция плавного скролла
    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    // Обработчики событий
    window.addEventListener('scroll', checkScroll);
    scrollBtn.addEventListener('click', scrollToTop);
    // Проверяем при загрузке
    checkScroll();


    const burgerBtn = document.querySelector('.burger-btn');
    const mobileMenu = document.querySelector('.mobile-menu');
    const body = document.body;

    // Открытие/закрытие меню
    burgerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        this.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        body.classList.toggle('menu-open');
    });

    // Закрытие меню при клике на ссылку
    const menuItems = mobileMenu.querySelectorAll('.mobile-menu__item');
    menuItems.forEach(item => {
        item.addEventListener('click', function () {
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            body.classList.remove('menu-open');
        });
    });

    // Закрытие меню при клике вне меню
    document.addEventListener('click', function (event) {
        if (!burgerBtn.contains(event.target) && !mobileMenu.contains(event.target)) {
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            body.classList.remove('menu-open');
        }
    });

    // Закрытие меню при нажатии Escape
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            burgerBtn.classList.remove('active');
            mobileMenu.classList.remove('active');
            body.classList.remove('menu-open');
        }
    });

    // Предотвращаем закрытие при клике внутри меню
    mobileMenu.addEventListener('click', function (e) {
        e.stopPropagation();
    });
});